module.exports = "/_next/static/images/broadband-labels-header-d82c27e26245a5413d8ff61e56d6f8b4.webp";